import { render, staticRenderFns } from "./permissionModal.vue?vue&type=template&id=4ffb362e"
import script from "./permissionModal.vue?vue&type=script&lang=js"
export * from "./permissionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports